(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-logos"] && !Shopify.designMode) return;
  try {
    
(function () {

  // ── Marquee carousel ──────────────────────────────────────
  document.querySelectorAll('[data-marquee]').forEach(function (stage) {
    if (stage.dataset.marqueeBound) return;
    stage.dataset.marqueeBound = '1';

    var track = stage.querySelector('[data-marquee-track]');
    if (!track) return;

    var count       = parseInt(stage.dataset.count    || '0',    10);
    if (count < 2) return;

    var autoplay    = stage.dataset.autoplay !== 'false';
    var interval    = parseInt(stage.dataset.interval || '3000', 10);
    var pvD         = parseInt(stage.dataset.pvD      || '3',    10);
    var pvT         = parseInt(stage.dataset.pvT      || '3',    10);
    var pvM         = parseInt(stage.dataset.pvM      || '2',    10);

    var prevBtn     = stage.querySelector('[data-marquee-prev]');
    var nextBtn     = stage.querySelector('[data-marquee-next]');
    var counterEl   = stage.querySelector('[data-marquee-counter]');
    var progressEl  = stage.querySelector('[data-marquee-progress]');

    var idx = 0, timer = null, animating = false;
    var progressRaf = null, progressStart = 0;

    function perView() {
      var w = window.innerWidth;
      return w >= 990 ? pvD : w >= 750 ? pvT : pvM;
    }

    function pad2(n) { return String(n).padStart ? String(n).padStart(2, '0') : (n < 10 ? '0' + n : String(n)); }

    function updateCounter() {
      if (!counterEl) return;
      var disp = ((idx % count) + count) % count + 1;
      counterEl.textContent = pad2(disp) + ' / ' + pad2(count);
    }

    function applyTransform(animated) {
      var pct = 100 / perView();
      track.style.transition = animated ? 'transform 0.65s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      track.style.transform  = 'translateX(-' + (idx * pct) + '%)';
    }

    function startProgress() {
      if (!progressEl || !autoplay) return;
      cancelAnimationFrame(progressRaf);
      progressStart = Date.now();
      progressEl.style.transition = 'none';
      progressEl.style.width = '0%';
      (function tick() {
        var elapsed = Date.now() - progressStart;
        var pct = Math.min(100, (elapsed / interval) * 100);
        progressEl.style.width = pct + '%';
        if (pct < 100) progressRaf = requestAnimationFrame(tick);
      })();
    }

    function resetProgress() {
      cancelAnimationFrame(progressRaf);
      if (progressEl) progressEl.style.width = '0%';
    }

    function step(dir) {
      if (animating) return;
      animating = true;
      idx += dir;
      updateCounter();
      applyTransform(true);
      resetProgress();
      setTimeout(function () {
        if (idx >= count) { idx -= count; applyTransform(false); }
        if (idx < 0)      { idx += count; applyTransform(false); }
        animating = false;
        if (timer) startProgress();
      }, 680);
    }

    function start() {
      clearInterval(timer);
      timer = null;
      if (autoplay && count > perView()) {
        startProgress();
        timer = setInterval(function () { step(1); }, interval);
      }
    }

    function stop() {
      clearInterval(timer);
      timer = null;
      resetProgress();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { stop(); step(-1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stop(); step(1);  start(); });

    var tX = 0, tY = 0;
    stage.addEventListener('touchstart', function (e) {
      tX = e.touches[0].clientX;
      tY = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - tX;
      var dy = e.touches[0].clientY - tY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) e.preventDefault();
    }, { passive: false });
    stage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tX;
      if (Math.abs(dx) > 40) { stop(); step(dx < 0 ? 1 : -1); start(); }
    }, { passive: true });

    var resizeRaf;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () { applyTransform(false); });
    }, { passive: true });

    updateCounter();
    applyTransform(false);
    start();
  });

  // ── Reveal on scroll ──────────────────────────────────────
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.dcm-mq').forEach(function (s) { io.observe(s); });
  } else {
    document.querySelectorAll('.dcm-mq').forEach(function (s) { s.classList.add('is-revealed'); });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clients"] && !Shopify.designMode) return;
  try {
    
(function () {

  // ── Marquee carousel ──────────────────────────────────────
  document.querySelectorAll('[data-marquee]').forEach(function (stage) {
    if (stage.dataset.marqueeBound) return;
    stage.dataset.marqueeBound = '1';

    var track = stage.querySelector('[data-marquee-track]');
    if (!track) return;

    var count       = parseInt(stage.dataset.count    || '0',    10);
    if (count < 2) return;

    var autoplay    = stage.dataset.autoplay !== 'false';
    var interval    = parseInt(stage.dataset.interval || '3000', 10);
    var pvD         = parseInt(stage.dataset.pvD      || '3',    10);
    var pvT         = parseInt(stage.dataset.pvT      || '3',    10);
    var pvM         = parseInt(stage.dataset.pvM      || '2',    10);

    var prevBtn     = stage.querySelector('[data-marquee-prev]');
    var nextBtn     = stage.querySelector('[data-marquee-next]');
    var counterEl   = stage.querySelector('[data-marquee-counter]');
    var progressEl  = stage.querySelector('[data-marquee-progress]');
    var sectionEl   = stage.closest('section');

    var idx = 0, timer = null, animating = false;
    var progressRaf = null, progressStart = 0;

    function perView() {
      var w = window.innerWidth;
      return w >= 990 ? pvD : w >= 750 ? pvT : pvM;
    }

    function pad2(n) { return String(n).padStart ? String(n).padStart(2, '0') : (n < 10 ? '0' + n : String(n)); }

    function updateCounter() {
      if (!counterEl) return;
      var disp = ((idx % count) + count) % count + 1;
      counterEl.textContent = pad2(disp) + ' / ' + pad2(count);
    }

    function applyTransform(animated) {
      var pct = 100 / perView();
      track.style.transition = animated ? 'transform 0.65s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      track.style.transform  = 'translateX(-' + (idx * pct) + '%)';
    }

    function startProgress() {
      if (!progressEl || !autoplay) return;
      cancelAnimationFrame(progressRaf);
      progressStart = Date.now();
      progressEl.style.transition = 'none';
      progressEl.style.width = '0%';
      (function tick() {
        var elapsed = Date.now() - progressStart;
        var pct = Math.min(100, (elapsed / interval) * 100);
        progressEl.style.width = pct + '%';
        if (pct < 100) progressRaf = requestAnimationFrame(tick);
      })();
    }

    function resetProgress() {
      cancelAnimationFrame(progressRaf);
      if (progressEl) progressEl.style.width = '0%';
    }

    function step(dir) {
      if (animating) return;
      animating = true;
      idx += dir;
      updateCounter();
      applyTransform(true);
      resetProgress();
      setTimeout(function () {
        if (idx >= count) { idx -= count; applyTransform(false); }
        if (idx < 0)      { idx += count; applyTransform(false); }
        animating = false;
        if (timer) startProgress();
      }, 680);
    }

    function start() {
      clearInterval(timer);
      timer = null;
      if (autoplay && count > perView()) {
        startProgress();
        timer = setInterval(function () { step(1); }, interval);
      }
    }

    function stop() {
      clearInterval(timer);
      timer = null;
      resetProgress();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { stop(); step(-1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stop(); step(1);  start(); });

    // Touch swipe
    var tX = 0, tY = 0;
    stage.addEventListener('touchstart', function (e) {
      tX = e.touches[0].clientX;
      tY = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - tX;
      var dy = e.touches[0].clientY - tY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) e.preventDefault();
    }, { passive: false });
    stage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tX;
      if (Math.abs(dx) > 40) { stop(); step(dx < 0 ? 1 : -1); start(); }
    }, { passive: true });

    var resizeRaf;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () { applyTransform(false); });
    }, { passive: true });

    updateCounter();
    applyTransform(false);
    start();
  });

  // ── Reveal on scroll ──────────────────────────────────────
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.dcm-mq').forEach(function (s) { io.observe(s); });
  } else {
    document.querySelectorAll('.dcm-mq').forEach(function (s) { s.classList.add('is-revealed'); });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-words"] && !Shopify.designMode) return;
  try {
    
(function () {
  var RADIUS = 1.5;

  function initSection(section) {
    if (section.dataset.swInit === 'true') return;
    section.dataset.swInit = 'true';

    var track = section.querySelector('.scroll-words__track');
    var words = Array.from(section.querySelectorAll('.scroll-words__word'));
    if (!track || words.length === 0) return;

    var ticking = false;
    var inView = true;

    // Cache last written values per word — skip the DOM write if
    // the rounded value hasn't changed since last frame. Cuts the
    // amount of style invalidation by ~5-10x on slow scroll.
    var lastOffsets = new Array(words.length).fill(NaN);
    var lastTs = new Array(words.length).fill(NaN);

    function paint(focus) {
      // Pure continuous: position and scale both follow the live
      // focus. Smooth scroll, no snap-feel.
      for (var i = 0; i < words.length; i++) {
        var offset = i - focus;
        var dist = Math.abs(offset);
        var t = Math.max(0, 1 - dist / RADIUS);
        var ss = t * t * (3 - 2 * t);
        var eased = ss * ss;
        // Quantise to 2dp so micro-scroll doesn't thrash style.
        var oQ = Math.round(offset * 100) / 100;
        var tQ = Math.round(eased * 1000) / 1000;
        if (oQ !== lastOffsets[i]) {
          words[i].style.setProperty('--offset', oQ.toFixed(2));
          lastOffsets[i] = oQ;
        }
        if (tQ !== lastTs[i]) {
          words[i].style.setProperty('--t', tQ.toFixed(3));
          lastTs[i] = tQ;
        }
      }
    }

    var exited = false;
    var collapsed = false;

    // Instant inline-style collapse. This is the ONLY approach
    // that worked cleanly on this layout, verified via live test:
    //
    //   Before:  scrollY=1625, doc_h=6587, cat_y=0
    //   After inline maxHeight=0:
    //            scrollY=754,  doc_h=5716, cat_y=0
    //   Delta:   scroll=-871,  doc=-871   (equal!)
    //
    // The browser's built-in scroll anchoring kicks in: it picks
    // the next sibling (categories) as the anchor and decreases
    // scrollY by exactly the doc-shrink amount in the same tick.
    // Categories stays at the same viewport y. Zero teleport.
    //
    // Why no fade animation? Two attempts at smoothing this with
    // CSS transitions or JS rAF both failed:
    //  - CSS transition: max-height !important was being silently
    //    dropped from computed style (browser bug for this layout
    //    with sticky descendants + overflow:clip)
    //  - JS rAF: animation worked in principle, but each tick
    //    re-triggered scroll-anchoring which on iOS Safari was
    //    NOT applying the per-frame adjustment, only the final
    //    big one — same teleport as before
    //
    // Instant inline collapse uses the ONE thing that's reliable
    // on iOS: a single, large doc-height change in one frame
    // triggers scroll-anchoring exactly once, cleanly. No
    // momentum interference, no compositor desync.
    function maybeFadeAndCollapse() {
      if (collapsed) return;
      var rect = section.getBoundingClientRect();
      if (rect.bottom > 0) return;
      collapsed = true;
      section.classList.add('is-fully-past');
      section.style.maxHeight = '0px';
      section.style.minHeight = '0';
      section.style.opacity = '0';
      section.style.overflow = 'hidden';
    }

    function update() {
      ticking = false;
      if (collapsed) return;

      // Past-the-viewport path: if the section's bottom is at or
      // above the viewport top, force-exit and try to collapse.
      // This branch must catch both fast-scroll-past AND the slow
      // case where the user drags to rect.bottom == 0 exactly.
      // (The normal path below bails on !inView, so without this
      // branch the trigger would never fire when the user stops
      // right at the section's edge.)
      var secRect = section.getBoundingClientRect();
      if (secRect.bottom <= 0) {
        if (!exited) {
          exited = true;
          section.classList.add('is-words-exited');
        }
        maybeFadeAndCollapse();
        return;
      }

      if (!inView) return;

      var rect = track.getBoundingClientRect();
      var vh = window.innerHeight;
      var scrollable = rect.height - vh;
      var scrolled = Math.max(0, Math.min(scrollable, -rect.top));
      var p = scrollable > 0 ? scrolled / scrollable : 0;
      // Linear focus — smooth & continuous, no stage feel. The sharp
      // peak comes from the t falloff in paint() (squared smoothstep)
      // rather than from biasing scroll progress.
      paint(p * (words.length - 1));
      // Once the user has fully scrolled through the words (p ~= 1),
      // fade the top half out and lock it that way for the rest of
      // the session. Doesn't reset on scroll-up — they only see the
      // words again after a hard refresh.
      if (!exited && p >= 0.985) {
        exited = true;
        section.classList.add('is-words-exited');
      }

      // Try to collapse on every scroll tick once exited — fires
      // once the section's bottom is comfortably above the viewport.
      maybeFadeAndCollapse();
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting;
          if (inView) update();
        });
      }, { rootMargin: '20% 0px 20% 0px' });
      io.observe(track);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    update();
  }

  function initAll() {
    document.querySelectorAll('.scroll-words').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
